import { render, staticRenderFns } from "./CoreActivityNotification.vue?vue&type=template&id=90fc9e86&"
import script from "./CoreActivityNotification.vue?vue&type=script&lang=js&"
export * from "./CoreActivityNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports